<scale-telekom-header type="slim" app-name="Finance 360" app-name-link="/">
  <scale-telekom-nav-list
    slot="functions"
    variant="functions"
    alignment="right"
    aria-label="User actions"
  >
    @if (authService.userProfile; as user) {
      <scale-telekom-nav-item variant="functions" aria-label="Sign out">
        <button
          class="nav-icon-btn"
          (click)="logout()"
          title="Sign out"
          aria-label="Sign out of Finance 360"
        >
          <scale-icon-user-file-logout size="20" />
          <span class="nav-btn-label">Sign out</span>
        </button>
      </scale-telekom-nav-item>
    }
  </scale-telekom-nav-list>
</scale-telekom-header>
